import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types";
import ConfigUtil from "../util/ConfigUtil";
import FetchUtil from "../util/FetchUtil";
// gleiches Design wie die Weiterleitung nach dem Scorer-Update und die Teilnahmebestätigung
import "./scorer/scorerRedirect.css";

export default function RegistrationComplete({userregistrationid, startseiteUrl}) {

    const [infoMessage, setInfoMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        registrierungAbschliessen();
    }, []);

    const registrierungAbschliessen = () => {
        setErrorMessage("");
        if (userregistrationid === null || userregistrationid === undefined || userregistrationid === "") {
            setErrorMessage("Aufruf dieser Seite ohne eine Registrierungs-ID ist nicht erlaubt.");
            return;
        }

        let url = ConfigUtil.getConfig().resourceUrls.user + "/registrationcomplete?userregistrationid=" + userregistrationid;
        FetchUtil.fetchPost(url,
            {},
            message => {
                if (message === "") {
                    setInfoMessage("Deine Registrierung ist abgeschlossen, du kannst dich jetzt anmelden.");
                } else {
                    setErrorMessage(message);
                }
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error);
            }
        );
    }

    const getStatus = () => {
        if (errorMessage !== "") {
            return {klasse: "dhsr-status-fehler", icon: "pi pi-times", titel: "Registrierung nicht möglich", text: errorMessage};
        }
        if (infoMessage !== "") {
            return {klasse: "dhsr-status-erfolg", icon: "pi pi-check", titel: "Registrierung abgeschlossen", text: infoMessage};
        }
        return {klasse: "dhsr-status-laden", icon: "pi pi-spin pi-spinner", titel: "Registrierung wird abgeschlossen", text: "Bitte einen Moment Geduld …"};
    }

    const status = getStatus();
    const erfolgreich = infoMessage !== "";

    return <div className="dhsr-seite">
        <main className="dhsr-karte">
            <a href={startseiteUrl} aria-label="Zur Startseite">
                <img className="dhsr-logo" alt="Darthelfer" src={"/images/darthelfer_quer_weiss.png"}/>
            </a>

            <div className={"dhsr-status " + status.klasse} aria-hidden="true">
                <i className={status.icon}/>
            </div>

            <div role="status" aria-live="polite">
                <h1 className="dhsr-titel">{status.titel}</h1>
                <p className="dhsr-text dhsr-abstand">{status.text}</p>
            </div>

            {erfolgreich ?
                // die Anmeldung erfolgt auf der Startseite
                <a className="dhsr-knopf" href={startseiteUrl}>
                    Jetzt anmelden
                    <i className="pi pi-arrow-right" aria-hidden="true"/>
                </a>
                :
                <a className="dhsr-link" href={startseiteUrl}>
                    <i className="pi pi-home" aria-hidden="true"/>
                    Zur Startseite
                </a>
            }
        </main>
    </div>
}

RegistrationComplete.propTypes = {
    userregistrationid: PropTypes.string,
    startseiteUrl: PropTypes.string,
};
